import { useState } from 'react';

import Column from '../../../../../components/Column/Column';
import Columns from '../../../../../components/Columns/Columns';
import determineCompatibilityForSingleOrMultiDay from '../../../../helpers/determineCompatibilityForSingleOrMultiDay';
import DockWithMedia from '../../../../types/DockWithMedia';
import DockCard from '../DockCard/DockCard';
import DockInfoModal from '../DockInfoModal/DockInfoModal';

type ListOfDocksProps = {
    docks: Array<DockWithMedia>;
    googleApiKey: string;
    customerWantsMultipleDays: boolean | undefined;
    onPreview: (dock: DockWithMedia) => void;
    onPreviewComplete: () => void;
    onSelectDock: (dock: DockWithMedia) => void;
};

const ListOfDocks = ({
    docks,
    googleApiKey,
    customerWantsMultipleDays,
    onPreviewComplete,
    onPreview,
    onSelectDock,
}: ListOfDocksProps) => {
    const [preview, setPreview] = useState<DockWithMedia>();
    const startPreview = (dock: DockWithMedia) => {
        setPreview(dock);
        onPreview(dock);
    };
    const cancelPreview = () => {
        setPreview(undefined);
        onPreviewComplete();
    };

    const selectDock = (dock: DockWithMedia) => {
        cancelPreview();
        onSelectDock(dock);
    };

    return (
        <div>
            <Columns
                gap="xlarge"
                collapsedGap="xlarge"
                collapseBelow="tablet"
                animatePresence
                wrap
                align="stretch"
            >
                {docks.map((dock) => {
                    const compatible =
                        determineCompatibilityForSingleOrMultiDay(
                            customerWantsMultipleDays,
                            dock.singleOrMultiDay
                        );

                    return (
                        <Column width="1/2" key={dock.id}>
                            <DockCard
                                incompatibleSingleOrMultiDay={!compatible}
                                dock={dock}
                                onSelect={selectDock}
                                onPreview={startPreview}
                            />
                        </Column>
                    );
                })}
            </Columns>

            {preview && (
                <DockInfoModal
                    onCloseRequested={cancelPreview}
                    dock={preview}
                    onSelect={selectDock}
                    googleApiKey={googleApiKey}
                />
            )}
        </div>
    );
};

export default ListOfDocks;
